import { ProtectRule } from '../components/etc/ProtectedRoute'
import { store } from '../redux/store'
import { ROUTES } from '../http/routes'

export const loginRule: ProtectRule = {
    check: () => !!store.getState().global.user.token,
    redirect: ROUTES.LOGIN,
}